export function openWindow(url) {
    window.open(url);
}
